import * as React from "react"
import { ClipboardCheck, FileText, Home, Inbox, LayoutDashboard, Map, Palette, Podcast, SearchCheck, Settings, Signpost, Sparkles, Users } from "lucide-react"
import { MainNav, type NavItemDef } from "@/components/MainNav"

const ADMIN_NAV_ITEMS: NavItemDef[] = [
  {
    href: "/admin",
    icon: LayoutDashboard,
    label: "Dashboard",
    match: (url) => url === "/admin" || url === "/admin/",
  },
  {
    href: "/admin/applications",
    icon: Inbox,
    label: "Applications",
    match: (url) => url.startsWith("/admin/applications"),
  },
  {
    href: "/admin/seo_audits",
    icon: SearchCheck,
    label: "SEO Audits",
    match: (url) => url.startsWith("/admin/seo_audits"),
  },
  {
    href: "/admin/podcast_scorecards",
    icon: ClipboardCheck,
    label: "Scorecards",
    match: (url) => url.startsWith("/admin/podcast_scorecards"),
  },
  {
    href: "/admin/podcast_audits",
    icon: Podcast,
    label: "Podcast Audits",
    match: (url) => url.startsWith("/admin/podcast_audits"),
  },
  {
    href: "/admin/posts",
    icon: FileText,
    label: "Blog",
    match: (url) => url.startsWith("/admin/posts"),
  },
  {
    href: "/admin/redirects",
    icon: Signpost,
    label: "Redirects",
    match: (url) => url.startsWith("/admin/redirects"),
  },
  {
    href: "/admin/users",
    icon: Users,
    label: "Users",
    match: (url) => url.startsWith("/admin/users"),
  },
  {
    href: "/admin/settings",
    icon: Settings,
    label: "Settings",
    match: (url) => url.startsWith("/admin/settings"),
  },
  {
    href: "/admin/pages",
    icon: Map,
    label: "Pages",
    match: (url) => url.startsWith("/admin/pages"),
  },
  {
    href: "/admin/design-system",
    icon: Palette,
    label: "Design System",
    match: (url) => url.startsWith("/admin/design-system"),
  },
  {
    href: "/admin/skills",
    icon: Sparkles,
    label: "Skills",
    match: (url) => url.startsWith("/admin/skills"),
  },
  {
    href: "/",
    icon: Home,
    label: "App Home",
    match: () => false,
  },
]

export function AdminShell({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex min-h-screen bg-page text-ink-body">
      <MainNav items={ADMIN_NAV_ITEMS} brandHref="/admin" />
      <main className="min-w-0 flex-1 px-6 py-8 sm:px-10">
        <div className="mx-auto max-w-4xl">{children}</div>
      </main>
    </div>
  )
}
